import { getText } from '../i18n';

function NotFoundPage() {
  return (
    <div>
      <h1 className="display-4 d-flex justify-content-center">{getText('msg_c35a9fc52bb5')}</h1>
      <p className="d-flex justify-content-center">
        {getText('msg_a32ea9d878a6')}
      </p>
    </div>
  );
}

export default NotFoundPage;
